module.exports = __webpack_public_path__ + "static/media/marker--priority-yellow.c6da365c.svg";